export default __webpack_public_path__ + "static/media/bell_gear.61fd490b.svg";